export const MIN_QTY = 1;
export const MAX_QTY = 10;
export const CART_STORAGE_KEY = 'shop:cart';
export const LAST_ORDER_STORAGE_KEY = 'shop:lastOrder';
export const CART_STORAGE_VERSION = 1;
